import { InputGroup, Input, InputRightElement } from "@chakra-ui/react";
import { Search } from "@airhelp/icons";
import type { FilterProps } from "./Filter.d";

const Filter = ({ filter, setFilter, placeholder }: FilterProps) => (
  <InputGroup mt={{ base: 4, md: 0 }} w={{ base: "full", md: 60 }}>
    <Input
      border="1px"
      borderColor="greyscale.400"
      color="greyscale.500"
      fontSize="md"
      type="text"
      value={filter || ""}
      onChange={({ target: { value } }) => setFilter(value)}
      placeholder={placeholder}
    />
    <InputRightElement>
      <Search w={4} h={4} mt={1} />
    </InputRightElement>
  </InputGroup>
);

export default Filter;
